import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface EthicsQualityEditor {
    _id: string;
    fullName: string;
    email: string;
}

interface EthicsQualityEditorContextType {
    ethicsQualityEditor: EthicsQualityEditor | null;
    token: string | null;
    isAuthenticated: boolean;
    logout: () => void;
    loading: boolean;
}

const EthicsQualityEditorContext = createContext<EthicsQualityEditorContextType>({
    ethicsQualityEditor: null,
    token: null,
    isAuthenticated: false,
    logout: () => { },
    loading: true
});

export const useEthicsQualityEditor = () => useContext(EthicsQualityEditorContext);

export const EthicsQualityEditorProvider = ({ children }: { children: ReactNode }) => {
    const [ethicsQualityEditor, setEthicsQualityEditor] = useState<EthicsQualityEditor | null>(null);
    const [token, setToken] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const storedToken = localStorage.getItem('ethicsQualityEditorToken');
        const storedEthicsQualityEditor = localStorage.getItem('ethicsQualityEditorData');

        if (storedToken && storedEthicsQualityEditor) {
            setToken(storedToken);
            setEthicsQualityEditor(JSON.parse(storedEthicsQualityEditor));
        }

        setLoading(false);
    }, []);

    const logout = () => {
        localStorage.removeItem('ethicsQualityEditorToken');
        localStorage.removeItem('ethicsQualityEditorData');
        setEthicsQualityEditor(null);
        setToken(null);
        // This role is embedded as a tab inside the unified dashboard, so logging out
        // here should return to the unified login, not this role's standalone one.
        window.location.href = '/login';
    };

    return (
        <EthicsQualityEditorContext.Provider value={{
            ethicsQualityEditor,
            token,
            isAuthenticated: !!token && !!ethicsQualityEditor,
            logout,
            loading
        }}>
            {children}
        </EthicsQualityEditorContext.Provider>
    );
};
